/** Race een promise tegen een timeout; gooit bij overschrijding. */
export function withTimeout<T> (
  promise: Promise<T>,
  ms: number,
  timeoutMessage = 'Het laden duurde te lang. Controleer je verbinding en probeer opnieuw.'
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = window.setTimeout(() => {
      reject(new Error(timeoutMessage))
    }, ms)

    promise
      .then(resolve, reject)
      .finally(() => window.clearTimeout(timer))
  })
}
